/**
 * Activity API
 * Domain API via HTTP transport (apiTransport) to the backend /api RPC.
 */

import { ActivityLog } from '@repo/shared-types';
import type { RouterContext } from './transport';
import { apiTransport as router } from './transport';

export interface OrgAuditActivityLogQuery {
  operatingOrganizationId: string;
  actorId?: string;
  targetEntityType?: string;
  targetEntityId?: string;
  take?: number;
}

export const activityApi = {
  logs: {
    list: async () => router.get<ActivityLog[]>('/activity/logs'),
    add: async (log: Omit<ActivityLog, 'id' | 'timestamp'>) => router.post<ActivityLog>('/activity/logs', log),
  },
  admin: {
    listOrgAudit: async (q: OrgAuditActivityLogQuery, context?: RouterContext) => {
      const filters: Record<string, string> = { operatingOrganizationId: q.operatingOrganizationId };
      if (q.actorId) filters.actorId = q.actorId;
      if (q.targetEntityType) filters.targetEntityType = q.targetEntityType;
      if (q.targetEntityId) filters.targetEntityId = q.targetEntityId;
      if (q.take != null) filters.take = String(q.take);
      return router.get<ActivityLog[]>('/admin/activity-logs', context, filters);
    },
  },
};

